<!--  -->
<template>
    <div class="Header">
        <div class="left">
            <img :src="require('../assets/zkjx.png')" class="w-[92px] h-[28px]"  />
            <!-- <img :src="aboutUsPicUrl || require('../assets/zkjx.png')" class="w-[92px] h-[28px]"  /> -->
        </div>
        <div class="flex items-center">
            <div class="flex items-center justify-end pr-2 cursor-pointer pl-[20px] h-[40px] rounded-[6px] relative head-name z-30">
                <div style="margin-right: 20px" @mouseenter="handleNoticeHover" @mouseleave="handleNoticeLeave">
                    <ele-notice/>
                    <!-- 通知悬停弹窗 -->
                    <div v-if="showNoticeTooltip" class="user-tooltip notice-tooltip">
                        <div class="tooltip-content">
                            <p>消息通知</p>
                        </div>
                    </div>
                </div>
                <div class="justify-sbetween user-info-container" @click="jumme" @mouseenter="handleUserHover" @mouseleave="handleUserLeave">
                    <el-image fit="fill" class="w-[26px] h-[26px] rounded-[100px] mr-[10px]" :src="avatar" />
                    {{ name }}
                    <!-- 用户信息悬停弹窗 -->
                    <div v-if="showUserTooltip" class="user-tooltip">
                        <div class="tooltip-content">
                            <div class="user-info-item">
                                <span class="label">登录账号：</span>
                                <span class="value">{{ userName || '暂无' }}</span>
                            </div>
                            <div class="user-info-item">
                                <span class="label">角色：</span>
                                <span class="value">{{ roleName || '暂无' }}</span>
                            </div>
                            <div class="user-info-item">
                                <span class="label">所属单位：</span>
                                <span class="value">{{ orgName || '暂无' }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="../assets/tuic.png" @click="logout" class="w-[16px] h-[16px] ml-20" style="cursor: pointer" />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import EleNotice from './notice';
    import { getInfo } from '@/api/login'
    export default {
        components: {EleNotice},
        computed: {
            ...mapGetters([
                'name',
                'avatar',
                'userName',
                'roleName',
                'orgName',
                'aboutUsPicUrl'
            ])
        },
        data() {
            return {
                showUserTooltip: false,
                showNoticeTooltip: false,
                hoverTimer: null
            };
        },
        watch: {},
        created() {},
        mounted() {},

        methods: {
            // 用户信息悬停处理
            handleUserHover() {
                // 如果用户信息不完整，先获取完整信息
                if (!this.userName || !this.roleName || !this.orgName) {
                    this.fetchUserInfo().then(() => {
                        this.showUserTooltip = true;
                    });
                } else {
                    this.showUserTooltip = true;
                }
            },
            handleUserLeave() {
                this.showUserTooltip = false;
            },
            // 通知悬停处理
            handleNoticeHover() {
                this.showNoticeTooltip = true;
            },
            handleNoticeLeave() {
                this.showNoticeTooltip = false;
            },
            // 获取完整用户信息
            fetchUserInfo() {
                return this.$store.dispatch('GetInfo');
            },
            jumme(){
                this.$router.push({
                    path: '/detail/personal',
                })
            },
            async logout() {
                this.$confirm('确定退出此账号吗？', '退出登录', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('LogOut').then(() => {
                        location.href = `/#/login?redirect=${this.$route.path}`;
                    })
                }).catch(() => {});
            }
        },
    };
</script>
<style scoped lang="scss">
    .Header {
        background-color: #649DE6;
        background-image: url("/src/assets/tbtw.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        height: 48px;
        padding: 0 34px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
            display: flex;
            align-items: center;
            .logo {
                height: 24px;
            }
        }

        .down {
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.12);
        }
        .down-item:hover, .notice:hover {
            background-color: #F4F4F4;
        }
        :deep(.el-badge) {
            .el-badge__content.is-fixed {
                /*top: 7px;*/
                /*right: 25px;*/
            }
        }
    }
    .head-name{
        color: white;
    }
    
    .user-info-container {
        position: relative;
    }
    
    .user-tooltip {
        position: absolute;
        top: 100%;
        right: 0;
        background: #fff;
        border: 1px solid #e4e7ed;
        border-radius: 6px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: 12px 16px;
        min-width: 200px;
        z-index: 1000;
        margin-top: 8px;
    }
    
    .user-tooltip::before {
        content: '';
        position: absolute;
        top: -6px;
        right: 20px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
    }
    
    .user-tooltip::after {
        content: '';
        position: absolute;
        top: -7px;
        right: 20px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #e4e7ed;
    }
    
    .notice-tooltip {
        right: 50px;
    }
    
    .notice-tooltip::before {
        right: 10px;
    }
    
    .notice-tooltip::after {
        right: 10px;
    }
    
    .tooltip-content {
        color: #606266;
        font-size: 14px;
        line-height: 1.4;
    }
    
    .user-info-item {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
    }
    
    .user-info-item:last-child {
        margin-bottom: 0;
    }
    
    .user-info-item .label {
        font-weight: 500;
        color: #909399;
        min-width: 70px;
        flex-shrink: 0;
    }
    
    .user-info-item .value {
        color: #303133;
        word-break: break-all;
    }
</style>
